import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';

import { formatDate } from '~/utils/utils';
import { useTrans } from '~/hooks/useTrans';
import { IInternalUser } from "~/providers/interfaces";
import Loader from '~/components/Loader';
import { userStore } from "~/stores/user";
import { useLang } from "~/hooks/useLang";

interface IInternalusersTable {
	loading: boolean;
	items: Array<IInternalUser>;
	onEdit: (user: IInternalUser) => void;
	onRemove: (user: IInternalUser) => void;
}

export default function InternalusersTable({
	loading = true,
	items = [],
	onEdit = () => {},
	onRemove = () => {},
}: IInternalusersTable) {
	const { trans, transInternalRole } = useTrans();
	const { isCzech } = useLang();
	const HEADERS = [
		"adminInternalUsersPage.table.id",
		"adminInternalUsersPage.table.source",
		"adminInternalUsersPage.table.email",
		"adminInternalUsersPage.table.createdAt",
		"adminInternalUsersPage.table.internalRole",
		"",
	];
	const { userData } = userStore(userState => ({
		userData: userState.user,
	}));

	return <TableContainer component={Paper}>
		<Table sx={{ minWidth: 650 }} aria-label="table">
			<TableHead>
				<TableRow>
					{ HEADERS.map(header => <TableCell sx={{ fontWeight: "bold" }} key={header}>
						{ header && trans(header) }
					</TableCell>) }
				</TableRow>
			</TableHead>
			<TableBody>
				{ items.map(user => (<TableRow key={user.id}>
					<TableCell>
						{ user.id }
					</TableCell>
					<TableCell>
						{ user.source }
					</TableCell>
					<TableCell>
						{ user.email }
					</TableCell>
					<TableCell>
						{ formatDate(new Date(user.createdAt), isCzech) }
					</TableCell>
					<TableCell>
						{ transInternalRole(user.internalRole) }
					</TableCell>
					<TableCell>
						<div style={{ display: "flex", gap: "var(--margin-small)", justifyContent: "center", alignItems: "center" }}>
							{ user.email !== userData.email && <>
								<Button color="success" onClick={() => onEdit(user)}>
									<EditIcon />
								</Button>
								<Button color="success" onClick={() => onRemove(user)}>
									<DeleteIcon />
								</Button>
							</> }
							{ user.email === userData.email && <span dangerouslySetInnerHTML={{ __html: "&nbsp;" }}></span> }
						</div>
					</TableCell>
				</TableRow>)) }
				{ items.length === 0 && <TableRow>
					<TableCell colSpan={HEADERS.length} style={{ textAlign: "center" }}>
						{ loading && <Loader msg={trans("loadingData")} /> }
						{ !loading && trans("emptyTable") }
					</TableCell>
				</TableRow> }
			</TableBody>
		</Table>
	</TableContainer>;
}
